import CultureInfo from "../../culture-info";
import { ITypedEntity } from "../base/typed-entity";

export interface IMailTemplate extends ITypedEntity {
    /**
     * Gets or sets the name.
     */
    name: string;

    /**
     * Gets the subject.
     * @param culture - The culture
     * @returns The subject.
     */
    getSubject(culture: CultureInfo): string;

    /**
     * Sets the subject.
     * @param culture - The culture
     * @param subject - The subject
     */
    setSubject(culture: CultureInfo, subject: string): void;

    /**
     * Gets the body.
     * @param culture - The culture
     * @returns The body.
     */
    getBody(culture: CultureInfo): string;

    /**
     * Sets the body.
     * @param culture - The culture
     * @param body - The body
     */
    setBody(culture: CultureInfo, body: string): void;

    /**
     * Gets the description.
     * @param culture - The culture
     * @returns The description.
     */
    getDescription(culture: CultureInfo): string;

    /**
     * Sets the description.
     * @param culture - The culture
     * @param description - The new description
     */
    setDescription(culture: CultureInfo, description: string): void;

    /**
     * Gets the template variables.
     * @returns A list of template variables.
     */
    // // getTemplateVariables(): Array<TemplateVariable>;

    // /**
    //  * Sets the template variables.
    //  * @param variables - A collection of template variables
    //  */
    // // setTemplateVariables(variables: Array<TemplateVariable>): void;
}
